import { render, staticRenderFns } from "./LogKelasX.vue?vue&type=template&id=42cd38d4&"
import script from "./LogKelasX.vue?vue&type=script&lang=js&"
export * from "./LogKelasX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports